import React, { useState } from 'react';
import { ProjectKeywordGq } from '../../../../../../graphql/projects/models/ProjectKeywordGq';
import VoxelSubtleButton from '../../../../../voxel/Buttons/VoxelSubtleButton';
import VoxelDataTableCell from '../../../../../voxel/DataTable/VoxelDataTableCell';
import { VoxelPopover } from '../../../../../voxel/Popover/VoxelPopover';
import { VoxelPopoverContent } from '../../../../../voxel/Popover/VoxelPopoverContent';
import { VoxelPopoverTrigger } from '../../../../../voxel/Popover/VoxelPopoverTrigger';
import VariantPopoverContent from './VariantPopoverContent';

export interface TableCellKeywordProps {
  keyword: ProjectKeywordGq;
  areVariantsLoading?: boolean;
  localVariant?: number;
  handleSelectVariant: (keywordId: number, variantId: number) => void;
}

export const TableCellKeyword: React.FC<TableCellKeywordProps> = (props) => {
  const { localVariant, keyword } = props;
  const [showVariants, setShowVariants] = useState(false);
  const localKeyword = localVariant
    ? keyword.keywordVariants.find((v) => v.id === localVariant)?.variant ?? keyword.keyword
    : keyword.keyword;

  return (
    <VoxelDataTableCell>
      {localKeyword}
      <VoxelPopover
        open={showVariants}
        onOpenChange={setShowVariants}
        enableArrow={true}
        offsetPx={10}
      >
        {!!keyword?.keywordVariants?.length && (
          <VoxelPopoverTrigger enableActive>
            <VoxelSubtleButton
              label={keyword.keywordVariants?.length?.toString()}
              className="!py-0"
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
              onMouseUp={(e) => e.stopPropagation()}
            />
          </VoxelPopoverTrigger>
        )}
        <VoxelPopoverContent>
          <VariantPopoverContent {...props} />
        </VoxelPopoverContent>
      </VoxelPopover>
    </VoxelDataTableCell>
  );
};

export default TableCellKeyword;
